export default __webpack_public_path__ + "fdb8677be08625975c16b02997ce5678.png";